import { send } from 'server';

export const sendCloseNotification = ({ actionId, windowSessionId = '' }) => send({
    ID: 31137,
    description: 'Submit Action Closed',
    responses: [31138, 31139],
    actionId,
    windowSessionId
});

export const getBonusDetails = ({ remoteBonusId, systemId }) => send({
    ID: 31118,
    responses: [31119, 31120],
    description: 'Get Bonus Details',
    returnWageringCoefficients: false,
    returnBonusTemplateDetails: true,
    returnGamingContexts: true,
    remoteBonusId,
    systemId
});
